// import { Button, Popover } from "antd";
// import React, { useState } from "react";
// import AuthLayout from "../AuthLayout/AuthLayout";
// import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";
// import InputField from "../../components/Input/Inputfeild";
// import EyeOnIcon from "../../assets/icons/eye-on.svg";
// import EyeOffIcon from "../../assets/icons/eye-off.svg";
// import "./CreateNewPwd.css";

// import * as Yup from "yup";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// const CreateNewPwd = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [isFocus, setIsFocus] = useState(false);
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [error, setError] = useState("");
//   const [errorMatch, setErrorMatch] = useState("");
//   const [enable, setEnable] = useState(true);

//   const history = useHistory();

//   const initialValues = {
//     newpassword: "",
//     confirmPassword: "",
//   };

//   const validationSchema = Yup.object({
//     newpassword: Yup.string().required("Please input your new password!"),
//     confirmPassword: Yup.string()
//       .oneOf([Yup.ref("newpassword"), null], "Passwords must match")
//       .required("Please confirm your new password!"),
//   });

//   const handleIconClick = () => {
//     setShowPassword((prev) => !prev);
//   };

//   const handleSubmit = (values, { setSubmitting }) => {
//     console.log("Form submitted with values:", values);
//   };

//   const getPasswordStrength = (password) => {
//     let score = 0;
//     // Ensure the password is at least 7 characters
//     if (password.length >= 7) score += 20;

//     // Check for uppercase letters
//     if (/[A-Z]/.test(password)) score += 10;

//     // Check for lowercase letters
//     if (/[a-z]/.test(password)) score += 10;

//     // Check for digits
//     if (/\d/.test(password)) score += 20;

//     // Check for special characters
//     if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 20;

//     // If the password has more than 7 characters, add an additional 20 points
//     if (score === 80 && password.length > 10) score += 20;
//     console.log("score", score);
//     return score;
//   };

//   const getProgressBarColor = (score) => {
//     if (score === 0) return "bg-transparent";
//     if (score < 40) return "bg-red";
//     if (score < 80) return "bg-yellow";
//     return "bg-green";
//   };

//   const getStrengthText = (score) => {
//     if (score < 40) {
//       return "This password is too weak. Try something stronger!";
//     } else if (score < 80) {
//       return "Not bad, but your password could be more secure!";
//     } else {
//       return "Your password is great. Nice work!";
//     }
//   };

//   const PasswordStrengthBar = ({ password }) => {
//     const strength = getPasswordStrength(password);
//     const colorClass = getProgressBarColor(strength);
//     const strengthText = getStrengthText(strength);

//     return (
//       <div className="progress-bar-container">
//         <div className={`progress-bar ${colorClass}`} style={{ width: `${strength}%` }}></div>
//         <p className="progress-bar-text">{strengthText}</p>
//       </div>
//     );
//   };

//   const handleOnChange = (event) => {
//     debugger;
//     setNewPassword(event);

//     var capitalRegex = new RegExp("(?=.*?[A-Z])");
//     var simpleRegex = new RegExp("(?=.*?[a-z])");
//     var digitRegex = new RegExp("(?=.*?[0-9])");
//     var specialCRegex = new RegExp("(?=.*?[#?!@$%^&*-])");

//     const upperCaseCheck = capitalRegex.test(event) === false;
//     const lowerCaseCheck = simpleRegex.test(event) === false;
//     const numberCheck = digitRegex.test(event) === false;
//     const specialCharacterCheck = specialCRegex.test(event) === false;
//     const lengthCheck = event.length >= 7;

//     // Update the popup styles
//     document.getElementById("uppercase").style.color = upperCaseCheck ? "red" : "green";
//     document.getElementById("lowercase").style.color = lowerCaseCheck ? "red" : "green";
//     document.getElementById("number").style.color = numberCheck ? "red" : "green";
//     document.getElementById("special-character").style.color = specialCharacterCheck ? "red" : "green";
//     document.getElementById("total-number").style.color = lengthCheck ? "green" : "red";

//     // Set error message if password field is empty
//     setError(event.trim() === "" ? "Password is required" : "");

//     // If confirm password is already entered, check if passwords match
//     if (confirmPassword !== "") {
//       if (event !== confirmPassword) {
//         setErrorMatch("The passwords should match");
//         setEnable(false);
//       } else {
//         setErrorMatch("");
//         setEnable(true);
//       }
//     }
//   };

//   const matchEnteredPasswords = (event) => {
//     setConfirmPassword(event);

//     if (newPassword === event) {
//       setErrorMatch("");
//       setEnable(true);
//     } else {
//       setErrorMatch("The passwords should match");
//       setEnable(false);
//     }

//     // Show error message if field is empty
//     if (event.trim() === "") {
//       setErrorMatch("Confirm password is required");
//     }
//   };

//   return (
//     <AuthLayout>
//       <div className="signin-container">
//         <div className="signin-header">
//           <h1>Create New Password</h1>
//           <p>Please enter a new password. Your new password must be different from previous password.</p>
//         </div>

//         <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
//           {({ isSubmitting, errors, touched }) => (
//             <FormikForm className="login-form">
//               <Popover
//                 open={isFocus}
//                 id="popover-create-password"
//                 content={
//                   <div alignment="start">
//                     <span type="text" className="eco-mb-20">
//                       The password must include
//                     </span>
//                     <div direction="row" verticalAlign="v_top">
//                       <div>
//                         <ul>
//                           <li id="total-number">
//                             <p className="pwd-strength-text" type="text">
//                               Minimum of 7 characters
//                             </p>
//                           </li>
//                           <li id="uppercase">
//                             <p className="pwd-strength-text" type="text">
//                               At least one uppercase letter
//                             </p>
//                           </li>
//                           <li id="lowercase">
//                             <p className="pwd-strength-text" type="text">
//                               At least one lowercase letter
//                             </p>
//                           </li>
//                           <li id="number">
//                             <p className="pwd-strength-text" type="text">
//                               At least one number
//                             </p>
//                           </li>
//                           <li id="special-character">
//                             <p className="pwd-strength-text" type="text">
//                               At least one special character
//                             </p>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 }
//                 trigger="click"
//                 placement="bottom"
//               >
//                 <div className="input-wrapper">
//                   <p>New Password</p>
//                   <Field name="newpassword">
//                     {({ field }) => (
//                       <InputField
//                         {...field}
//                         type={showPassword ? "text" : "password"}
//                         placeholder="Password"
//                         icon={showPassword ? EyeOnIcon : EyeOffIcon}
//                         iconClick={handleIconClick}
//                         onChange={(e) => handleOnChange(e.target.value)}
//                         value={newPassword}
//                         onFocus={() => {
//                           setIsFocus(true);
//                         }}
//                         onBlur={() => {
//                           setIsFocus(false);
//                         }}
//                         className={`custom-input ${errors.newpassword && touched.newpassword ? "input-error" : ""}`}
//                       />
//                     )}
//                   </Field>
//                   <PasswordStrengthBar password={newPassword} />
//                   <ErrorMessage name="newpassword" component="div" className="error-message" />
//                 </div>
//               </Popover>

//               <div className="input-wrapper">
//                 <p>Confirm Password</p>
//                 <Field name="confirmPassword">
//                   {({ field }) => (
//                     <InputField
//                       {...field}
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Confirm Password"
//                       icon={showPassword ? EyeOnIcon : EyeOffIcon}
//                       value={confirmPassword}
//                       iconClick={handleIconClick}
//                       onChange={(e) => {
//                         matchEnteredPasswords(e.target.value);
//                       }}
//                       className={`custom-input ${
//                         errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
//                       }`}
//                     />
//                   )}
//                 </Field>
//                 <ErrorMessage name="confirmPassword" component="div" className="error-message" />
//               </div>

//               <div className="remember-me-container">
//                 <div className="remember-me-wrapper">
//                   <Field name="remember" type="checkbox" />
//                   <label htmlFor="remember"> Remember me</label>
//                 </div>
//                 <label
//                   htmlFor="forget-password"
//                   className="forget-password"
//                   onClick={() => history.push("/forget-password")}
//                 >
//                   Forgot password?
//                 </label>
//               </div>

//               <Button htmlType="submit" type="primary" className="signin-btn" disabled={isSubmitting}>
//                 {isSubmitting ? "Signing in..." : "Sign in"}
//               </Button>
//             </FormikForm>
//           )}
//         </Formik>
//       </div>
//     </AuthLayout>
//   );
// };

// export default CreateNewPwd;
import { Button, Popover } from "antd";
import React, { useState } from "react";
import AuthLayout from "../AuthLayout/AuthLayout";
import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";
import InputField from "../../components/Input/Inputfeild";
import EyeOnIcon from "../../assets/icons/eye-on.svg";
import EyeOffIcon from "../../assets/icons/eye-off.svg";
import "./CreateNewPwd.css";
import * as Yup from "yup";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PwdSuccess from "../../assets/Images/success-bg.png";

const CreateNewPwd = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const history = useHistory();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [liveValidation, setLiveValidation] = useState({
    confirmPassword: null, // null: not validated, true: match, false: no match
  });

  const [pwdSuccess, setPwdSuccess] = useState(false);

  const initialValues = {
    newpassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    newpassword: Yup.string().required("Please input your new password!"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newpassword"), null], "Passwords must match")
      .required("Please confirm your new password!"),
  });

  const handleIconClick = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = (values, { setSubmitting }) => {
    console.log("Form submitted with values:", values);
    // submit logic here
    setSubmitting(false);
  };

  const getPasswordStrength = (password) => {
    let score = 0;
    if (password.length >= 7) score += 20;
    if (/[A-Z]/.test(password)) score += 10;
    if (/[a-z]/.test(password)) score += 10;
    if (/\d/.test(password)) score += 20;
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 20;
    if (score === 80 && password.length > 10) score += 20;
    return score;
  };

  const getProgressBarColor = (score) => {
    if (score === 0) return "bg-transparent";
    if (score < 40) return "bg-red";
    if (score < 80) return "bg-yellow";
    return "bg-green";
  };

  const getStrengthText = (score) => {
    if (score < 40) return "This password is too weak. Try something stronger!";
    if (score < 80) return "Not bad, but your password could be more secure!";
    return "Your password is great. Nice work!";
  };

  const PasswordStrengthBar = ({ password }) => {
    const strength = getPasswordStrength(password);
    const colorClass = getProgressBarColor(strength);
    const strengthText = getStrengthText(strength);

    return (
      <div className="progress-bar-container">
        <div className={`progress-bar ${colorClass}`} style={{ width: `${strength}%` }}></div>
        <p className="progress-bar-text">{strengthText}</p>
      </div>
    );
  };

  const updatePasswordRulesColors = (password) => {
    const rules = {
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      minLength: password.length >= 7,
    };

    document.getElementById("uppercase").style.color = rules.uppercase ? "green" : "red";
    document.getElementById("lowercase").style.color = rules.lowercase ? "green" : "red";
    document.getElementById("number").style.color = rules.number ? "green" : "red";
    document.getElementById("special-character").style.color = rules.specialChar ? "green" : "red";
    document.getElementById("total-number").style.color = rules.minLength ? "green" : "red";
  };

  const handleConfirmPasswordIconClick = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Live validation for confirm password
  const validateConfirmPassword = (confirmPassword, newPassword) => {
    if (!confirmPassword) {
      setLiveValidation({ confirmPassword: null });
      return;
    }

    if (confirmPassword === newPassword) {
      setLiveValidation({ confirmPassword: true });
    } else {
      setLiveValidation({ confirmPassword: false });
    }
  };

  // Live validation message component
  const LiveValidationMessage = ({ field, validation }) => {
    if (validation === null) return null;

    return (
      <div className={`live-validation-message ${validation ? "success" : "error"}`}>
        {validation ? (
          <span style={{ color: "green" }}>✓ Passwords match</span>
        ) : (
          <span style={{ color: "red" }}>✗ Passwords do not match</span>
        )}
      </div>
    );
  };

  return (
    <AuthLayout>
      <div className="signin-container">
        {!pwdSuccess ? (
          <>
            <div className="signin-header">
              <h1>Create New Password</h1>
              <p>Please enter a new password. Your new password must be different from previous password.</p>
            </div>

            <Formik
              validateOnChange={true}
              validateOnBlur={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, errors, touched, values, handleChange, setFieldValue }) => (
                <FormikForm className="login-form">
                  <Popover
                    open={isFocus}
                    id="popover-create-password"
                    content={
                      <div alignment="start">
                        <span className="eco-mb-20">The password must include</span>
                        <ul>
                          <li id="total-number">
                            <p className="pwd-strength-text">Minimum of 7 characters</p>
                          </li>
                          <li id="uppercase">
                            <p className="pwd-strength-text">At least one uppercase letter</p>
                          </li>
                          <li id="lowercase">
                            <p className="pwd-strength-text">At least one lowercase letter</p>
                          </li>
                          <li id="number">
                            <p className="pwd-strength-text">At least one number</p>
                          </li>
                          <li id="special-character">
                            <p className="pwd-strength-text">At least one special character</p>
                          </li>
                        </ul>
                      </div>
                    }
                    trigger="click"
                    placement="bottom"
                  >
                    <div className="input-wrapper">
                      <p>New Password</p>
                      <Field name="newpassword">
                        {({ field }) => (
                          <InputField
                            {...field}
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            icon={showPassword ? EyeOnIcon : EyeOffIcon}
                            iconClick={handleIconClick}
                            onChange={(e) => {
                              field.onChange(e);
                              updatePasswordRulesColors(e.target.value);
                              // Re-validate confirm password when new password changes
                              validateConfirmPassword(values.confirmPassword, e.target.value);
                            }}
                            onFocus={() => setIsFocus(true)}
                            onBlur={() => setIsFocus(false)}
                            value={values.newpassword}
                            className={`custom-input ${errors.newpassword && touched.newpassword ? "input-error" : ""}`}
                          />
                        )}
                      </Field>
                      <PasswordStrengthBar password={values.newpassword} />
                      <ErrorMessage name="newpassword" component="div" className="error-message" />
                    </div>
                  </Popover>

                  <div className="input-wrapper">
                    <p>Confirm Password</p>
                    <Field name="confirmPassword">
                      {({ field }) => (
                        <InputField
                          {...field}
                          type={showConfirmPassword ? "text" : "password"}
                          placeholder="Confirm Password"
                          icon={showConfirmPassword ? EyeOnIcon : EyeOffIcon}
                          iconClick={handleConfirmPasswordIconClick}
                          value={values.confirmPassword}
                          onChange={(e) => {
                            handleChange(e);
                            // Live validation on every keystroke
                            validateConfirmPassword(e.target.value, values.newpassword);
                          }}
                          className={`custom-input ${
                            errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
                          } ${liveValidation.confirmPassword === false ? "input-error" : ""} ${
                            liveValidation.confirmPassword === true ? "input-success" : ""
                          }`}
                        />
                      )}
                    </Field>

                    {/* Live validation message */}
                    <LiveValidationMessage field="confirmPassword" validation={liveValidation.confirmPassword} />
                  </div>

                  <Button htmlType="submit" type="primary" className="signin-btn" disabled={isSubmitting}>
                    {isSubmitting ? "Resetting..." : "Reset Password"}
                  </Button>
                </FormikForm>
              )}
            </Formik>
          </>
        ) : (
          <div className="pwd-success-container">
            <img src={PwdSuccess} alt="Success" className="success-image" />
            <h1>You have successfully changed your password</h1>

            <Button type="primary" className="signin-btn pwd-success-btn" onClick={() => history.replace("/signin")}>
              Back to Login
            </Button>
          </div>
        )}
      </div>
    </AuthLayout>
  );
};

export default CreateNewPwd;
